<template><tile-question-layout v-if="panel_required" :options_loaded="options_loaded" :passed_filter="passed_filter" :panel_required="panel_required" :title="title" :loading="loading" v-model:target="localTarget" :filtered_option_list="filtered_option_list" :thumb_url="thumbURL" :component_id="component_id" :fabricator="fabricator">

</tile-question-layout></template>

<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Select your escutcheon';
                }
            },
            component_id: {
                default(){
                    return 'hardware_escutcheon';
                }
            },
            slab: {
                required: true
            },
            hardwareColour: {
                required: true
            },
            securedByDesign: {
                required: true
            },
            hardwareHandle: {
                required: true
            },
            doorRange: {
                required: true
            },
            profile: {
                required: true
            },
            hardwareHandleInternal: {
              default(){
                return 0;
              }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.slab, this.hardwareColour, this.securedByDesign, this.hardwareHandle, this.doorRange, this.profile, this.hardwareHandleInternal);
            },
            thumbURL(){
                return '/thumb/hardware/';
            },
            url(){
                return '/api/options/' + this.fabricator + '/hardware-escutcheon?secured_by_design=' + this.securedByDesign + '&slab=' + this.slab + '&hardware_colour=' + this.hardwareColour + '&hardware_handle=' + this.hardwareHandle + '&door_range=' + this.doorRange + '&profile=' + this.profile + '&hardware_handle_internal=' + this.hardwareHandleInternal;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.hardwareColour + '_' + this.securedByDesign + '_' + this.hardwareHandle + '_' + this.doorRange + '_' + this.profile + '_' + this.hardwareHandleInternal;
            },
            filtered_option_list(){
                if (this.option_list === null) {
                    return [];
                }

                if (!Array.isArray(this.option_list)) {
                    return [];
                }

                return this.option_list.filter((key)=> {
                    return key.value !== null && !!key.value;
                });
            },
            panel_required(){
                return Array.isArray(this.filtered_option_list) && this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
